/* Scorrimento infinito di collezioni e ricerca (snippets/axr-infinite.liquid, Impostazioni tema → Aventurx — Elenco prodotti).
   - Le pagine successive si chiedono a Shopify con la sola sezione (section_id) e i loro prodotti si aggiungono all'elenco.
   - Si caricano da sole fino a "data-auto" pagine, poi serve il bottone: così si arriva al piè di pagina.
   - Filtri e ordine del tema rifanno il riquadro: qui ci si riaggancia da soli al nuovo (MutationObserver).
   - Tornando indietro da un prodotto si ricaricano le stesse pagine e si torna allo stesso punto.
   - Senza JavaScript restano le pagine numerate (nascoste solo quando questo file gira). */
(function () {
  'use strict';
  if (window.axrInfinite) return;
  window.axrInfinite = true;
  document.documentElement.classList.add('axr-inf-js');

  var KEY = 'axrInfBack';
  var MAX_RESTORE = 8;
  var AHEAD = 900; // px prima della fine dell'elenco in cui parte la pagina successiva

  function text(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function num(v) { return parseInt(v, 10) || 0; }
  function listOf(box) {
    var sec = box.closest('[data-section-id]') || document;
    return sec.querySelector('[data-ajax-container="products"] .product-list');
  }
  function keyOf(el) {
    if (el.dataset && el.dataset.productId) return 'p' + el.dataset.productId;
    var inner = el.querySelector && el.querySelector('[data-product-id]');
    if (inner) return 'p' + inner.getAttribute('data-product-id');
    var a = el.querySelector && el.querySelector('a[href]');
    return a ? 'u' + a.getAttribute('href').split('?')[0] : '';
  }
  // solo prodotti (e risultati della ricerca): niente riquadri promozionali né la testata della collezione
  function usable(el) {
    if (el.nodeType !== 1) return false;
    if (el.querySelector('.product-promotion, .product-list-heading-block')) return false;
    return true;
  }
  function withSection(url, id) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
  }
  function pageUrl(url, page) {
    var u = new URL(url, location.href);
    if (page > 1) u.searchParams.set('page', page); else u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  function paint(box) {
    var st = box._axrInf;
    var total = num(box.dataset.total);
    var size = num(box.dataset.size) || 1;
    var from = (st.first - 1) * size + 1;
    var to = Math.min(st.last * size, total);
    var count = box.querySelector('[data-axr-inf-count]');
    if (count) {
      if (st.error) count.textContent = box.dataset.tError;
      else if (!st.next && st.first === 1) count.textContent = text(box.dataset.tDone, { total: total });
      else if (st.first > 1) count.textContent = text(box.dataset.tRange, { from: from, to: to, total: total });
      else count.textContent = text(box.dataset.tCount, { shown: to, total: total });
    }
    var bar = box.querySelector('[data-axr-inf-bar]');
    if (bar) bar.style.width = (total ? Math.min(100, Math.round(to * 100 / total)) : 100) + '%';
    var btn = box.querySelector('[data-axr-inf-more]');
    if (btn) {
      btn.hidden = !st.next;
      btn.disabled = st.busy;
      btn.classList.toggle('is-loading', st.busy);
      btn.textContent = st.busy ? box.dataset.tLoading : (st.error ? box.dataset.tRetry : box.dataset.tMore);
    }
    box.classList.toggle('is-done', !st.next);
  }

  function append(box, doc) {
    var list = listOf(box);
    var incoming = doc.querySelector('[data-ajax-container="products"] .product-list');
    if (!list || !incoming) return 0;
    var seen = {};
    Array.prototype.forEach.call(list.children, function (el) { var k = keyOf(el); if (k) seen[k] = 1; });
    var frag = document.createDocumentFragment();
    var added = 0;
    Array.prototype.slice.call(incoming.children).forEach(function (el) {
      if (!usable(el)) return;
      var k = keyOf(el);
      if (k && seen[k]) return;
      if (k) seen[k] = 1;
      frag.appendChild(document.adoptNode(el));
      added++;
    });
    list.appendChild(frag);
    // animazioni d'ingresso del tema e componenti come dopo un filtro
    try { if (window.theme && typeof window.theme.initAnimateOnScroll === 'function') window.theme.initAnimateOnScroll(); } catch (e) { /* tema senza animazioni */ }
    try { document.dispatchEvent(new CustomEvent('axr:products-added', { detail: { list: list } })); } catch (e) { /* browser vecchio */ }
    return added;
  }

  function load(box, auto) {
    var st = box._axrInf;
    if (!st || st.busy || !st.next) return Promise.resolve(false);
    st.busy = true;
    st.error = false;
    if (auto) st.autoLeft--;
    paint(box);
    var url = st.next;
    return fetch(withSection(url, box.dataset.section), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (!document.contains(box)) return false; // filtri cambiati nel frattempo: risposta vecchia
        var doc = new DOMParser().parseFromString(html, 'text/html');
        append(box, doc);
        var nb = doc.querySelector('[data-axr-inf]');
        st.next = nb ? nb.dataset.next : '';
        st.last = nb ? num(nb.dataset.page) : st.last + 1;
        st.busy = false;
        paint(box);
        schedule();
        return true;
      })
      .catch(function () {
        st.busy = false;
        st.error = true;
        if (auto) st.autoLeft = 0;
        paint(box);
        return false;
      });
  }

  // scorrimento: quando la fine dell'elenco si avvicina (o è già passata, es. tasto Fine) parte la pagina dopo
  function check() {
    document.querySelectorAll('[data-axr-inf]').forEach(function (box) {
      var st = box._axrInf;
      if (!st || st.busy || st.error || !st.next || st.autoLeft <= 0 || st.restoring) return;
      if (box.getBoundingClientRect().top < window.innerHeight + AHEAD) load(box, true);
    });
  }
  var ticking = false;
  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; check(); });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  function setup(box) {
    if (box._axrInf) return;
    var page = num(box.dataset.page) || 1;
    box._axrInf = { first: page, last: page, next: box.dataset.next || '', busy: false, error: false, autoLeft: num(box.dataset.auto) };
    var btn = box.querySelector('[data-axr-inf-more]');
    if (btn) btn.addEventListener('click', function () { load(box, false); });
    if (page > 1 && !box.querySelector('[data-axr-inf-first]')) {
      var a = document.createElement('a');
      a.className = 'axr-inf__first';
      a.setAttribute('data-axr-inf-first', '');
      a.href = pageUrl(location.href, 1);
      a.textContent = box.dataset.tFirst;
      var list = listOf(box);
      if (list && list.parentNode) list.parentNode.insertBefore(a, list);
    }
    paint(box);
  }

  function scan() {
    document.querySelectorAll('[data-axr-inf]').forEach(setup);
  }

  // ---- ritorno da un prodotto: stesse pagine, stesso punto ----
  function listKey() { return pageUrl(location.href, 0); }
  document.addEventListener('click', function (evt) {
    var a = evt.target instanceof Element && evt.target.closest('a[href]');
    if (!a || !a.closest('[data-ajax-container="products"]')) return;
    var box = document.querySelector('[data-axr-inf]');
    if (!box || !box._axrInf || box._axrInf.last <= box._axrInf.first) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ url: listKey(), first: box._axrInf.first, last: box._axrInf.last, y: window.scrollY, t: Date.now() }));
    } catch (e) { /* storage non disponibile */ }
  }, true);

  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) { return; }
    if (!saved || saved.url !== listKey() || Date.now() - saved.t > 30 * 60000) return;
    var box = document.querySelector('[data-axr-inf]');
    if (!box || !box._axrInf || box._axrInf.first !== saved.first) return;
    var target = Math.min(saved.last, box._axrInf.first + MAX_RESTORE);
    var st = box._axrInf;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    st.restoring = true;
    (function step() {
      if (st.last >= target || !st.next) {
        st.restoring = false;
        st.autoLeft = Math.max(0, st.autoLeft - (st.last - st.first));
        paint(box);
        window.scrollTo(0, saved.y);
        return;
      }
      load(box, false).then(function (ok) { if (ok) step(); else st.restoring = false; });
    })();
  }

  scan();
  restore();
  schedule();
  // filtri e ordine del tema sostituiscono il riquadro: ci si riaggancia al nuovo
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); schedule(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
